import React from "react";
import Header from "./Header";
import "../css/gp.css";
import Footer from "./Footer";
function gp() {
  return (
    <div>
      {" "}
      <Header></Header>
      <div className="google">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-3">
              <h3>01</h3>
              <p>Google Page Experience Signal and SEO</p>
              <h3>01</h3>
              <p>Google Page Experience Signal and SEO</p>
              <h3>01</h3>
              <p>Google Page Experience Signal and SEO</p>
              <h3>01</h3>
              <p>Google Page Experience Signal and SEO</p>
              <h3>01</h3>
              <p>Google Page Experience Signal and SEO</p>
              <h3>01</h3>
              <p>Google Page Experience Signal and SEO</p>
            </div>
            <div className="col-md-8">
              <h3>Google Page Experience Signal and SEO</h3>
              <p>
                Is your website stuck <b>on the second,</b> third or fourth page
                of search engine results pages (SERPs) despite your on-page SEO
                efforts? Your website user experience may be the problem.
                <br />
                <br />
                Google has made its mission clear to make information{" "}
                <b> universally accessible and provide</b> online users with a
                high-quality on-page experience. And for a while now, Google has
                been using several search engine ranking signals, such as
                click-through rate (CTR), dwell time and bounce rate, to better
                rank web pages.
                <br />
                <br />
                If page visitors land on your website and are not satisfied with
                their page experience, they will bounce away and Google might
                consider it an indication that your web page does not deliver
                value to online users, making it difficult to rank higher in
                search results.
              </p>
              <img
                src="https://thriveagency.com/wp-content/themes/thrive-agency/images/google-update-image.svg"
                alt=""
              />
              <h3>
                Why Is It Important to Begin Optimizing <br />
                for the Google Page Experience Now?
              </h3>
              <div className="row">
                <div className="col-lg-6">
                  <p>
                    Websites must optimize for all Google Page Experience
                    ranking signals and meet the minimum threshold for all three
                    Core Web Vitals to qualify for the ranking boost.
                    <br />
                    <br />
                    Given the 28-day turnaround, optimizing your website user
                    experience too late in the game could negatively affect your
                    overall ranking and Search performance. Likewise, it would
                    be too late then to perform all the necessary updates to
                    achieve a good score on the Google Core Web Vitals
                    assessment and pass the Google performance test.
                  </p>
                </div>
                <div className="col-lg-6">
                  <img
                    src="https://thriveagency.com/wp-content/themes/thrive-agency/images/piller-google-image.svg"
                    alt=""
                  />
                </div>
                <div className="col-12">
                  <p>
                    Have you begun your optimization process for the Google Core
                    Web Vitals and Google Page Experience Guide? To better
                    understand the new Google update and guide your optimization
                    process, let us first define user experience and its role in
                    SEO and responsive web design.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  );
}

export default gp;
